export const color = "rgb(24, 144, 255)";
export const medium = "https://shravanmeena.medium.com/";
export const instagram = "https://www.instagram.com/shravanmeena99/";
export const linkedin = "https://www.linkedin.com/in/shravanmeena/";
export const twitter = "https://twitter.com/shravan70017147/";
export const github = "https://github.com/ShravanMeena";
export const youtube =
  "https://www.youtube.com/channel/UC-zcylRGah3ijAibsr34PWw/videos";
